// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_6oL","delete":"styles_delete__ia9X2","update":"styles_update__1CTcG","add":"styles_add__-ZoS6"};